import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import './QuotesLoader.css';

interface Props {
  count?: number;
}

const QuotesLoader = ({ count = 9 }: Props) => (
  <Row className="mt-4">
    {
      Array.apply(null, Array(count)).map((_, index) => (
        <Col key={index} md={4} style={{ marginBottom: 20 }}>
          <Card className="bar-loader" style={{ minHeight: 125 }} />
        </Col>
      ))
    }
  </Row>
);

export default QuotesLoader;
